import { ComponentChildren } from 'preact';

export const AccordionContent = ({ children }: { children: ComponentChildren }) => (
  <div class="cc-accordion-content">{children}</div>
);
